<template lang='pug'>
  i.svg-icon.svg-icon-delete
    svg(
      :fill='color'
      :width='`${size}px`'
      :height='`${size}px`'
      style='transform: rotate(45deg);'
      viewBox='0 0 100 100')

      path(d='M50,5.32C25.361,5.32,5.32,25.361,5.32,50S25.361,94.68,50,94.68S94.68,74.635,94.68,50S74.639,5.32,50,5.32 z M50,87.758c-20.817,0-37.758-16.937-37.758-37.758c0-20.821,16.941-37.758,37.758-37.758S87.758,29.179,87.758,50 C87.758,70.821,70.821,87.758,50,87.758z')

      path(d='M70.612,46.565h-16.49v-16.49c0-2.275-1.843-4.123-4.122-4.123c-2.28,0-4.123,1.848-4.123,4.123v16.49 H29.387c-2.28,0-4.123,1.847-4.123,4.123c0,2.275,1.842,4.123,4.123,4.123h16.491v16.49c0,2.274,1.843,4.123,4.123,4.123 c2.279,0,4.122-1.849,4.122-4.123v-16.49h16.49c2.281,0,4.124-1.848,4.124-4.123C74.736,48.413,72.894,46.565,70.612,46.565z')


</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#333',
    },
  },
};

</script>
